export default __webpack_public_path__ + "static/media/c002-PPII-13.8579d6fd.svg";